import { useEffect, useRef } from 'react';

type CallbackFunction<T extends any[] = any[]> = (...args: T) => void | null | undefined;

const useButtonPress = <T extends any[]>(callback?: CallbackFunction<T>): (() => void) => {
  const timerRef = useRef<ReturnType<typeof setTimeout>>();
  const isPressed = useRef(false);

  const handlePress = (...params: T) => {
    if (isPressed.current) {
      return;
    }
    isPressed.current = true;
    callback?.(...params); 
    timerRef.current = setTimeout(() => (isPressed.current = false), 1000); 
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return handlePress;
};

export default useButtonPress;
